import { Permissions } from 'mapistry-shared';
import { useMemo } from 'react';
import { useCurrentUser } from './useCurrentUser';
import { useOrganizationProjects } from './useOrgProjects';
import { useCurrentUserPermissions } from './permissions/useHasPermissions';
import { getUserPermissions, PermissionCategory } from '../utils/permissions';

export function useOrgProjectsForUserWithPermission(
  organizationId?: string,
  permission: Permissions = Permissions.PROJECT_DETAILS_READ,
) {
  const { currentUser, isLoading: isLoadingUser } = useCurrentUser();
  const { projects, isLoading: isLoadingProjects } = useOrganizationProjects({
    organizationId,
  });
  const { userPermissions, isLoading: isLoadingPermissions } =
    useCurrentUserPermissions();

  const isLoading = isLoadingUser || isLoadingProjects || isLoadingPermissions;

  const projectsWithPermission = useMemo(() => {
    if (!projects || !currentUser || !userPermissions) return undefined;
    return projects.filter((project) =>
      getUserPermissions(
        userPermissions,
        currentUser.id,
        project.id,
        PermissionCategory.PROJECT,
      ).includes(permission),
    );
  }, [projects, currentUser, userPermissions, permission]);

  return { projects: projectsWithPermission, isLoading };
}
